import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
//Import formik validation
import { Spinner } from "reactstrap";

//Import Images
import house_icon from "../../assets/images/auth_home_icon.png";
import config from "../../config";
import { Input } from "antd";
import { toast } from "react-toastify";
import { showErrorToast, showSuccessToast } from "../utils";
import { useAuth } from "../../contexts/AuthContext";
import { useProfile } from "../../contexts/ProfileContext";

const VerifyOTP = () => {
    const location = useLocation();
    const data = location.state;
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();
    const { loginUserSuccess } = useAuth();
    const { fetchProfile } = useProfile();
    const [email, setEmail] = React.useState(data ? data.email : "");
    const [otp, setOtp] = React.useState("");
    const [resendTimer, setResendTimer] = React.useState(0);
    const [canResend, setCanResend] = React.useState(true);

    useEffect(() => {
        if (!data) {
            navigate("/forgot-password");
        }
    }, [data]);

    useEffect(() => {
        let interval = null;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer((timer) => timer - 1);
            }, 1000);
        } else if (resendTimer === 0 && !canResend) {
            setCanResend(true);
        }
        return () => clearInterval(interval);
    }, [resendTimer, canResend]);

    const handleOtpVerification = async (e) => {
        e.preventDefault();
        if (!otp) {
            showErrorToast("Please enter 6 digit OTP", { autoClose: 3000, pauseOnHover: false });
            return;
        } else {
            e.preventDefault();
            setLoading(true);
            const requestUrl = `${config.get("API_URL")}/user/verify-otp`;
            const postData = {
                email,
                code: otp,
                purpose: "verification",
            };

            try {
                const response = await fetch(requestUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(postData),
                });

                if (!response.ok) {
                    const errorResponse = await response.json(); // Assuming the server sends a JSON response for errors
                    return showErrorToast("Invalid OTP. Please try again.", {
                        autoClose: 3000,
                        pauseOnHover: false,
                    });
                }

                const responseJSON = await response.json();

                if (responseJSON.message) {
                    if (data.from) {
                        toast.success("OTP verified successfully");

                        // Store tokens in localStorage
                        localStorage.setItem("authUser", JSON.stringify(responseJSON.access_token));
                        localStorage.setItem("refreshToken", JSON.stringify(responseJSON.refresh_token));

                        // Update AuthContext with login success
                        loginUserSuccess({
                            user: responseJSON.user || {},
                            token: responseJSON.access_token,
                        });

                        // Fetch fresh profile data
                        await fetchProfile();

                        return navigate("/properties");
                    }

                    navigate("/reset-password", { state: { email: email, otp } });
                } else {
                    throw new Error(responseJSON.message || "Verification failed: No success message received");
                }
            } catch (error) {
                showErrorToast(error.message || "Verification failed. Please try again.", {
                    autoClose: 3000,
                    pauseOnHover: false,
                });
            } finally {
                setLoading(false);
            }
        }
    };
    const onInput = (value) => {};

    const resendOTP = async (e) => {
        if (!email || !canResend) {
            return;
        }
        setOtp("");
        setCanResend(false);
        setResendTimer(30);

        try {
            const response = await fetch(`${config.get("API_URL")}/user/resend-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                },
                body: JSON.stringify({
                    email: email,
                    purpose: "verification",
                }),
            });

            const data = await response.json();

            if (response.ok) {
                showSuccessToast("Check your email for the verification code.");
            } else {
                showErrorToast(data.error);
                console.error("Error:", data.error);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
    document.title = `Verify OTP | ${config.get("COMPANY_NAME")}`;
    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("Text").trim();
        const cleaned = pastedData.replace(/\s+/g, ""); // Remove all spaces

        if (/^\d{6}$/.test(cleaned)) {
            setOtp(cleaned);
        } else {
            showErrorToast("Invalid OTP format. Please enter 6 digits.", {
                autoClose: 3000,
                pauseOnHover: false,
            });
        }
    };

    return (
        <div className="auth-main-wrapper">
            <div
                className="md:tw-bg-none tw-bg-center tw-bg-cover tw-w-full tw-h-full tw-flex tw-justify-between max-sm:tw-overflow-y-scroll"
                style={{ backgroundImage: `url(${house_icon})` }}
            >
                <div
                    style={{ backgroundImage: `url(${house_icon})` }}
                    className="max-sm:tw-hidden tw-relative tw-bg-center tw-bg-cover tw-w-full tw-m-2 "
                >
                    <div className="tw-absolute tw-inset-0 tw-bg-black tw-opacity-30"></div>

                    <div className="tw-absolute tw-top-[40px] tw-left-[30px] tw-flex tw-gap-2 tw-z-10">
                        <img
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/5c704c298b9ced9c12fdf92061da095dec0b48ab751d0dab56ea704d9d9b3733?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                            alt="AiRE BROKERS logo"
                            className="logo tw-w-[35px] tw-h-[35px]"
                        />
                        <span className={`brandName tw-text-[16px] `}>{config.get("COMPANY_NAME")}</span>
                    </div>
                </div>

                <div
                    // style={{ background: "rgba(0, 0, 0, 0.68)" }}
                    className="tw-h-full max-sm:tw-h-fit tw-w-full tw-self-end tw-pb-[70px] md:tw-pb-0 max-sm:tw-text-white max-sm:tw-bg-blur_background max-sm:tw-backdrop-blur-lg max-sm:tw-rounded-tl-[40px] max-sm:tw-rounded-tr-[40px] md:tw-px-10 max-sm:tw-px-3 max-sm:tw-mt-40 tw-flex tw-overflow-y-auto tw-justify-center tw-z-10 tw-min-h-0"
                >
                    <div className="md:tw-max-w-[526px] 2xl:tw-max-w-[721px] tw-h-full tw-items-center tw-flex tw-justify-center tw-pt-5 tw-w-full max-sm:tw-mt-6 max-sm:tw-mb-3 tw-px-4">
                        <div className="tw-flex tw-flex-col tw-gap-4 max-sm:tw-gap-3 2xl:tw-gap-5 tw-w-full">
                            <div className="tw-flex tw-flex-col tw-gap-3 max-sm:tw-gap-2">
                                <h1 className="tw-text-[36px] tw-font-semibold tw-text-center 2xl:tw-text-[50px] max-sm:tw-text-[22px] tw-leading-tight">
                                    Verify your OTP
                                </h1>
                                <p className="tw-text-[16px] max-sm:tw-text-[14px] tw-text-center 2xl:tw-text-[18px] md:tw-text-semi_dark_text tw-px-2 tw-leading-relaxed">
                                    We have sent a 6-digit verification code to <span className="tw-font-medium tw-break-all">{email}</span>
                                </p>
                                <p className="tw-text-[16px] max-sm:tw-text-[14px] tw-text-center 2xl:tw-text-[18px] md:tw-text-semi_dark_text tw-px-2">
                                    Please enter the code to verify your email
                                </p>
                            </div>

                            <form onSubmit={handleOtpVerification} className="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-w-full">
                                <div className="tw-w-full tw-max-w-[320px] max-sm:tw-max-w-[280px] tw-min-h-[55px] tw-flex tw-flex-col tw-gap-1 2xl:tw-gap-3 tw-px-2">
                                    {/* <span className="tw-text-[15px] max-sm:tw-text-[13px] max-sm:tw-font-thin">Enter OTP</span> */}
                                    <Input.OTP
                                        aria-required
                                        length={6}
                                        value={otp}
                                        onPaste={handlePaste}
                                        size="large"
                                        className="tw-w-full max-sm:tw-text-sm"
                                        onChange={(val) => setOtp(val)}
                                        onInput={onInput}
                                    />
                                </div>
                                <div className="tw-flex tw-flex-col tw-w-full tw-max-w-[320px] max-sm:tw-max-w-[280px] tw-px-2 tw-mt-4">
                                    <button
                                        type="button"
                                        onClick={(e) => resendOTP(e)}
                                        className="tw-flex tw-justify-center tw-items-center tw-gap-1 tw-text-[14px] max-sm:tw-text-[12px] tw-text-center tw-mb-4 tw-flex-wrap"
                                        disabled={!canResend}
                                    >
                                        <span className="max-sm:tw-text-center">Didn't receive the code?</span>
                                        <span className={`tw-cursor-pointer ${canResend ? "tw-text-primary" : "tw-text-gray-400"}`}>
                                            {canResend ? "Resend" : `Resend in ${resendTimer}s`}
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleOtpVerification}
                                        type="submit"
                                        className="tw-bg-primary tw-border-none tw-text-white tw-p-3 tw-px-6 max-sm:tw-px-4 tw-rounded-md tw-text-[16px] max-sm:tw-text-[14px] 2xl:tw-text-[18px] tw-w-full tw-min-h-[48px]"
                                        disabled={loading ? true : false}
                                    >
                                        {loading ? <Spinner size="sm" color="light" /> : "Verify Email"}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => window.history.back()}
                                        className="tw-flex tw-justify-center tw-items-center tw-gap-1 tw-text-[14px] max-sm:tw-text-[12px] tw-text-center tw-mt-4 tw-flex-wrap"
                                    >
                                        <span>Wrong Email?</span>
                                        <span className="tw-text-primary tw-cursor-pointer">Go Back & Edit</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyOTP;
